export default __webpack_public_path__ + "static/media/HkCall.af7cafa9.svg";